import Axios from "@/global/AxiosCall";
import {url} from '@/configs/apiUrl'

/**
 * default API response structure
 * {
 *     code: <integer>,
 *     message: <string>,
 *     data: <object>
 * }
 */
export default class DeviceAPI {

    static ImportFromExcel(payload) {
        return new Promise(((resolve, reject) => {
            let formData = new FormData();
            formData.append('file', payload.file);

            Axios.PostUpload(url.svd.device.import_excel, formData).then((result) => {
                if (result.code === 200)
                    resolve(result)
            }).catch((error) => {
                reject(error)
            });
        }))
    }
}
